<!-- src/views/Cancel.vue -->
<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-theme-bg2 px-4">
    <!-- Animated Failure Icon -->
    <div class="flex items-center justify-center w-20 h-20 rounded-full bg-red-100 mb-6 animate-bounce">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-12 h-12 text-red-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>

    <!-- Title -->
    <h1 class="text-3xl font-bold text-theme-text mb-2">Payment Canceled</h1>

    <!-- Message -->
    <p class="text-theme-text2 text-center mb-6">
      Your payment could not be completed. Please try again or use a different payment method.
    </p>

    <!-- Retry Button -->
    <router-link
      to="/checkout"
      class="px-6 py-3 rounded-2xl bg-red-600 text-white font-medium shadow-md hover:bg-red-700 transition duration-300 ease-in-out"
    >
      Try Again
    </router-link>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import axios from "axios";
import { useLogger } from '@/composables/useLogger';

const logger = useLogger('PaypalFailure');
const api_base_url = import.meta.env.VITE_API_BASE_URL;

onMounted(async () => {
  try {
    // ✅ direct axios call without axios.create
    const res = await axios.post(`${api_base_url}/api/paypal/cancel`, {}, { withCredentials: true });
    logger.info('PayPal cancel reported', { data: res.data });
  } catch (err) {
    logger.error('PayPal cancel report failed', err?.response?.data || err.message);
  }
});
</script>

